var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { isCesiumIonAssetEndpoint, isCesiumIonAssetInfo, isCesiumIonExternalAssetEndpoint, } from "./index";
import { FileLoader } from "../loaders";
/**
 * This class provides access to the CesiumIon
 */
export class CesiumIon {
    /**
     * Constructs a new CesiumIon connection with the provided access token
     * @param token The cesium access token to use with all network requests
     * @param options
     */
    constructor(token, options) {
        this.token = token;
        this.tokenHeaderValue = `Bearer ${token}`;
    }
    /**
     * Performs a request against the v1/assets/${assetId} cesium endpoint to get metadata information about the
     * requested asset.
     *
     * This does not return info for actually using the asset.
     *
     * @param assetId The numeric ID of the asset to lookup
     */
    getAssetInfo(assetId) {
        return __awaiter(this, void 0, void 0, function* () {
            const info = yield FileLoader.loadJson(`https://api.cesium.com/v1/assets/${assetId}`, {
                headers: {
                    Authorization: this.tokenHeaderValue,
                },
            });
            if (!isCesiumIonAssetInfo(info)) {
                throw new Error("CesiumIonAssetInfo response does not match interface");
            }
            else {
                return info;
            }
        });
    }
    /**
     * Performs a request against the v1/assets/${assetId}/endpoint cesium endpoint to get the asset info that is needed
     * to actually use the asset for visualization.
     *
     * This will yield an object that contains a description of the endpoints where the actual asset data will be
     * available from.
     *
     * @param assetId The numeric ID of the asset to lookup.
     */
    getAssetEndpoint(assetId) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = yield FileLoader.loadJson(`https://api.cesium.com/v1/assets/${assetId}/endpoint`, {
                headers: {
                    Authorization: this.tokenHeaderValue,
                },
            });
            if (isCesiumIonExternalAssetEndpoint(endpoint)) {
                return {
                    endpoint,
                    isExternal: true,
                };
            }
            else if (isCesiumIonAssetEndpoint(endpoint)) {
                return {
                    endpoint,
                    isExternal: false,
                };
            }
            else {
                throw new Error("AssetEndpoint response does not match interface");
            }
        });
    }
}
